<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style>
body {
  margin: 0px !important;
  height: 100%;
  color: #303133;
}
#app {
  height: 100%;
}
</style>
